// src/analytics.js

import ReactGA from 'react-ga4';

let isGAInitialized = false;
const PRODUCTION_HOSTS = ['list-link.com', 'www.list-link.com'];

export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

  if (!measurementId) {
    console.warn('Google Analytics: REACT_APP_GA_MEASUREMENT_ID not set. Analytics will not be initialized.');
    return;
  }

  if (typeof window === 'undefined') {
    return;
  }

  const currentHost = window.location.hostname;

  if (!PRODUCTION_HOSTS.includes(currentHost)) {
    console.info(`Google Analytics skipped for host: ${currentHost}`);
    return;
  }

  try {
    ReactGA.initialize(measurementId, {
      gaOptions: {
        cookieDomain: currentHost,
      },
    });
    isGAInitialized = true;
  } catch (error) {
    console.error('Failed to initialize Google Analytics:', error);
  }
};

export const logPageView = (path) => {
  if (!isGAInitialized) {
    return;
  }

  try {
    ReactGA.send({ hitType: 'pageview', page: path });
  } catch (error) {
    console.error('Failed to log page view:', error);
  }
};

export const logEvent = (category = '', action = '', label = '') => {
  if (!isGAInitialized || !category || !action) {
    return;
  }

  try {
    ReactGA.event({ category, action, label });
  } catch (error) {
    console.error('Failed to log event:', error);
  }
};
